'use client';

import { c as _c } from "react/compiler-runtime";
import { Textarea } from 'design-system/client';
import { forwardRef } from 'react';
import { type FieldValues } from 'react-hook-form';
import useFormErrorMessage from '../ActionForm/useFormErrorMessage';
import { FormTextareaProps } from './types';
const FormTextArea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(function FormTextArea(t0, ref) {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    const {
      className,
      ...t1
    } = t0;
    props = t1;
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const name = props.name ?? "";
  const error = useFormErrorMessage(name);
  let t1;
  if ($[2] !== error || $[3] !== props || $[4] !== ref) {
    t1 = <Textarea {...props} ref={ref} error={error} />;
    $[2] = error;
    $[3] = props;
    $[4] = ref;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
});
export default FormTextArea;